module.exports = __webpack_public_path__ + "img/fopeaVacaMuerta7.af2c9577.jpg";